import { isMobile, isTablet, isDesktop } from '../utilities/check-device-resolution';

/**
 * Vars
 */
const $header = $('.js-header');
const $nav = $('.js-nav');
const tabletWidth = 1023;
const $navDropdown = $('.js-nav-dropdown');

/**
 * Show nav on trigger click
 */

$nav.on('click', '.js-nav-trigger', function(event) {
	event.preventDefault();

	if (isMobile() || isTablet()) {
		$header.add($nav).toggleClass('is-active');
	}
});

/**
 * Show dropdown menu on click
 */

$navDropdown.find('> a').on('click', function(event) {
	if (isMobile() || isTablet()) {
		event.preventDefault();

		const $this = $(this);

		$this
			.next()
			.stop()
			.slideToggle()
				.parent()
				.toggleClass('is-active')
				.siblings()
				.removeClass('is-active')
				.children('a')
				.next()
				.stop()
				.slideUp();
	}
});

/**
 * Reset styles on resize
 */

$(window).on('resize', function(event) {
	if (isDesktop()) {
		$navDropdown
			.find('ul')
			.removeAttr('style')
			.end()
			.removeClass('is-active');
	}
});
